export const defaultValues = {
  firstName: null,
  secondName: null,
  surname: null,
  secondSurname: null,
  documentType: null,
  documentNumber: null,
  charge: null,
  duration: null,
  typePermission: null,
  description: null,
  initDate: null,
  endDate: null,
  remuner: null,
  regional: null,
  applicationDate: new Date(),
  observations: null,
};
export const defaultSearchValues = {
  firstName: null,
  lastName: null,
  regionalId: null,
  initDate: null,
  endDate: null,
  status: null,
};
export const defaultCreateValues = {
  laboratoryName: null,
  regional: null,
  status: null,
  email: null,
  phone: null,
  address: null,
};

export const ordenType = [
  "Ingreso",
  "Retiro",
  "Periodico",
  "Postincapacidad",
  "Reubicación laboral",
];
export const headers = {
  initialHeaders: [
    {
      title: "Nombre del laboratorio",
      field: "laboratoryName",
      child: null,
    },
    {
      title: "Estado",
      field: "status",
      child: null,
    },
    {
      title: "Regional",
      field: "regionalName",
      child: null,
    },
    {
      title: "Dirección",
      field: "address",
      child: null,
    },
    {
      title: "Telefono",
      field: "telephone",
      child: null,
    },
    {
      title: "Correo",
      field: "email",
      child: null,
    },
  ],
  otherHeaders: [
    {
      title: "Nombre del laboratorio",
      field: "laboratoryName",
      child: null,
    },
    {
      title: "Estado",
      field: "status",
      child: null,
    },
    {
      title: "Regional",
      field: "regionalName",
      child: null,
    },
    {
      title: "Correo",
      field: "email",
      child: null,
    },
    {
      title: "Dirección",
      field: "address",
      child: null,
    },
    {
      title: "Telefono",
      field: "telephone",
      child: null,
    },
  ],
};
